// Statisk registrering av alle Capacitor-plugins som ellers ville brukt
// `() => import('./web').then(m => new m.SomethingWeb())` internt.
//
// Bakgrunn (samme bug-klasse for alle pluginene): når den dynamiske importen
// kjøres gjennom Vite sin __vitePreload-helper og noe feiler, kaller helperen
// vite:preloadError-handleren vår. Den preventDefaults (for å reloade siden),
// og dermed swallower Vite feilen — den dynamiske importen resolver til
// `undefined` i microtask-køen før reload faktisk skjer. Neste
// `.then(m => new m.SomethingWeb())` kaster da:
//
//   TypeError: Cannot read properties of undefined (reading 'SomethingWeb')
//
// Som er gjentakende monitoring-issues (#12862 GenericOAuth2Web, #12824 DeviceWeb, ...).
//
// Vi løser det ved å pre-registrere hver plugin med en synkron web-factory FØR
// pakkenes egen index.js får sjansen til å kjøre sin `registerPlugin(...)`-kall.
// Capacitor sin registerPlugin returnerer eksisterende proxy ved duplikat-kall
// (med en console.warn), så pakkenes egne `export { Something }` ender opp
// pekende på vår statisk-registrerte proxy.
//
// VIKTIG: Denne fila MÅ importeres FØR `./app-root.js` i src/index.ts, ellers
// får pakkenes egen index.js kjørt først og fixen er ute av kraft.
// Se issue #12862 / #12824 — fixen har blitt overskrevet av merge tidligere.

import { registerPlugin } from '@capacitor/core';

import type { AppPlugin } from '@capacitor/app';
import { AppWeb } from '@capacitor/app/dist/esm/web';
import type { BrowserPlugin } from '@capacitor/browser';
import { BrowserWeb } from '@capacitor/browser/dist/esm/web';
import type { DevicePlugin } from '@capacitor/device';
import { DeviceWeb } from '@capacitor/device/dist/esm/web';
import type { GenericOAuth2Plugin } from '@capacitor-community/generic-oauth2';
import { GenericOAuth2Web } from '@capacitor-community/generic-oauth2/dist/esm/web';
import type { InAppBrowserPlugin } from '@capgo/inappbrowser';
import { InAppBrowserWeb } from '@capgo/inappbrowser/dist/esm/web';
import type { AppUpdatePlugin } from '@capawesome/capacitor-app-update';
import { AppUpdateWeb } from '@capawesome/capacitor-app-update/dist/esm/web';
import type { LiveUpdatePlugin } from '@capawesome/capacitor-live-update';
import { LiveUpdateWeb } from '@capawesome/capacitor-live-update/dist/esm/web';
import type { SecureStoragePluginPlugin } from 'capacitor-secure-storage-plugin';
import { SecureStoragePluginWeb } from 'capacitor-secure-storage-plugin/dist/esm/web';

registerPlugin<AppPlugin>('App', { web: () => new AppWeb() });
registerPlugin<BrowserPlugin>('Browser', { web: () => new BrowserWeb() });
registerPlugin<DevicePlugin>('Device', { web: () => new DeviceWeb() });
registerPlugin<GenericOAuth2Plugin>('GenericOAuth2', { web: () => new GenericOAuth2Web() });
registerPlugin<InAppBrowserPlugin>('InAppBrowser', { web: () => new InAppBrowserWeb() });
registerPlugin<AppUpdatePlugin>('AppUpdate', { web: () => new AppUpdateWeb() });
registerPlugin<LiveUpdatePlugin>('LiveUpdate', { web: () => new LiveUpdateWeb() });
registerPlugin<SecureStoragePluginPlugin>('SecureStoragePlugin', { web: () => new SecureStoragePluginWeb() });
